import { render, staticRenderFns } from "./examineManage.vue?vue&type=template&id=b2c22856&scoped=true&"
import script from "./examineManage.vue?vue&type=script&lang=js&"
export * from "./examineManage.vue?vue&type=script&lang=js&"
import style0 from "./examineManage.vue?vue&type=style&index=0&lang=less&"
import style1 from "./examineManage.vue?vue&type=style&index=1&id=b2c22856&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c22856",
  null
  
)

export default component.exports